import { createContext } from "react";

export type SessionPreferencesContextType = {
    fieldsFilter: {
        accountManager: string | null;
        csp: string | null;
        farm: string | null;
        search: string | null;
    };
    setFieldsFilter: (
        fieldsFilter: SessionPreferencesContextType["fieldsFilter"],
    ) => void;
    homeFilters: {
        globalFilter: string | null;
        columnFilters: {
            id: string | null;
            value: string | null;
        }[];
    };
    setHomeFilters: (
        homeFilters: SessionPreferencesContextType["homeFilters"],
    ) => void;
};

const SessionPreferencesContext =
    createContext<SessionPreferencesContextType | null>(null);

export default SessionPreferencesContext;
